import React, {useState} from 'react'
import styled from 'styled-components'
import Link from '../../commons/Link'
import H2 from '../../commons/H2'
import AdvantagesText from '../quintoPuoi/AdvantagesText'
import PensionatiText from '../quintoPuoi/PensionatiText'
import DipendentiPrivatiText from '../quintoPuoi/DipendentiPrivatiText'
import DipendentiPubbliciText from '../quintoPuoi/DipendentiPubbliciText'
import checkIcon from '../../../img/spli.svg'
import Tabs from '../../commons/Tabs'

const TripleTab = () => {
  const [tabToShow, setTabToShow] = useState(1)

  return (
    <Boxcon>
      <BoxconInner>
        <StyledH2>SCEGLI IL FINANZIAMENTO CHE FA PER TE IN BASE AL TUO PROFILO</StyledH2>
      </BoxconInner>
      <Tabs
        ariaLabel={'Scegli il finanziamento in base al tuo profilo'}
        activeIndex={tabToShow - 1}
        onChange={(i) => setTabToShow(i + 1)}
        items={[
          {
            id: 'pensionati',
            label: 'Sei un pensionato?',
            content: (
              <BoxconInner>
                <AdvantagesText />
                <PensionatiText />
              </BoxconInner>
            ),
          },
          {
            id: 'dipendenti-pubblici',
            label: 'Sei un dipendente pubblico?',
            content: (
              <BoxconInner>
                <AdvantagesText />
                <DipendentiPubbliciText />
              </BoxconInner>
            ),
          },
          {
            id: 'dipendenti-privati',
            label: 'Sei un dipendente privato?',
            content: (
              <BoxconInner>
                <AdvantagesText />
                <DipendentiPrivatiText />
              </BoxconInner>
            ),
          },
        ]}
      />
      <LinkContainer>
        <Link text={'RICHIEDI PREVENTIVO GRATUITO**'} link={'#preventivatore2'}/>
      </LinkContainer>
    </Boxcon>
  )
}

// region Style
const Boxcon = styled.div`
  background: #fff;
  border-radius: 33px;
  box-shadow: 0 0 50px rgb(0 0 0 / 20%);
  margin: 6rem 0;
`
const BoxconInner = styled.div`
  text-align: initial;
  @media (min-width: 769px) {
    padding: 5rem;
  }
  padding: 1.5rem;
`
const StyledH2 = styled(H2)`
  font-weight: 700;
  font-size: 29px;
  color: #2E2E2E;
  margin-bottom: 0 !important;
`
const LinkContainer = styled.div`
  padding-bottom: 3rem;
  text-align: center;
  flex: 0 0 100%;
  max-width: 100%;
`
// endregion

export default TripleTab
